import React, { useState, useEffect, useRef, useContext } from 'react';

import { Chart } from 'primereact/chart';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';

import { getProduccionFechaExport, getProduccionFechaSemanaExport } from '../../../API/Produccion/KPIs/KPIs';

import {
    borderRadius, borderColorCotton, colorCotton, borderColorSintetico, colorSintetico, footer,
    heightKPI, datalabelsBar, datalabelsLine, getRangeWeek, getScales, getTitle
} from '../../../utils/KPIs/productionUtils';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
const ExportProduction = () => {

    const { config } = useContext(ConfigContext);

    const scales = getScales(config);
    const colorTitle = getTitle(config);

    const toast = useRef(null);
    const [dates, setDates] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [exportWeek, setExportWeek] = useState(null);
    const [exportDay, setExportDay] = useState(null);
    const [ExportDataWeek, setExportDataWeek] = useState({
        OptionsWeek: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Export (Kg)',
                    color: colorTitle
                },
                datalabels: datalabelsBar,
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
            },
            scales: scales,
        },
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Export (Kg)',
                },
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales,
        },
        data: null
    });
    const [ExportDataDay, setExportDataDay] = useState({
        OptionsWeek: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Export (Kg)',
                    color: colorTitle
                },
                datalabels: datalabelsBar,
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
            },
            scales: scales,
        },
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Export (Kg)',
                    color: colorTitle
                },
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales,
        },
        data: null
    });


    const getInfo = async () => {
        // setExportWeek({
        //     KgsCF: 0,
        //     KgsCS: 0,
        //     Semana: 0,
        // });
        // setExportDay({
        //     days: [],
        //     KgsEXC: [],
        //     KgsRTS: [],
        // });
        if (dates) {
            setLoading(true);
            const rangeWeeks = getRangeWeek(dates)

            const tempo = await getProduccionFechaSemanaExport(rangeWeeks);
            const tempo2 = await getProduccionFechaExport(rangeWeeks);
            const aux = {
                days: [],
                KgsEXC: [],
                KgsRTS: [],
            }
            const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            days.forEach((day) => {
                const tempo = tempo2.find((item) => item.NombreDia === day);
                if (tempo) {
                    aux.days.push(day);
                    aux.KgsEXC.push(tempo.KgsCF);
                    aux.KgsRTS.push(tempo.KgsSF);
                }else{
                    aux.days.push(day);
                    aux.KgsEXC.push(0);
                    aux.KgsRTS.push(0);
                }
            });
            setExportWeek(tempo[0]);
            setExportDay(aux);
        } else {
            toastShow(toast, 'warn', 'Seleccione una fecha.')
        }
        setLoading(false)
    }

    useEffect(() => {
        window.document.title = 'PPF • Export Production'
        getInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (exportWeek) {
            setExportDataWeek({
                ...ExportDataWeek,
                dataWeek: {
                    labels: [`Semana ${exportWeek.Semana}`],
                    datasets: [{
                        type: 'bar',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: borderColorCotton,
                        borderWidth: 2,
                        data: [exportWeek.KgsCF],
                        stack: 'Stack 0',
                        borderRadius: borderRadius
                    },
                    {
                        type: 'bar',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: [exportWeek.KgsSF],
                        stack: 'Stack 1',
                        borderRadius: borderRadius
                    }
                    ]
                }
            })
        }else{
            setExportDataWeek({
                ...ExportDataWeek,
                dataWeek: null
            })
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exportWeek])

    useEffect(() => {
        if (exportDay) {
            setExportDataDay({
                ...ExportDataDay,
                dataDay: {
                    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    datasets: [{
                        type: 'line',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: borderColorCotton,
                        borderWidth: 2,
                        data: exportDay.KgsEXC,
                        borderRadius: borderRadius,
                        stack: 'Stack 0',
                    },
                    {
                        type: 'line',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: exportDay.KgsRTS,
                        borderRadius: borderRadius,
                        stack: 'Stack 1',
                    }
                    ]
                }
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exportDay])



    return (
        <div className='p-3'>
            <Card titulo={<h4>Export</h4>} contenido={
                (<div className='p-3 transitionAll-1 kpiProducction'>
                    <div>
                        <Toast position="bottom-right" ref={toast} />
                        <CalendarWeek
                            date={dates}
                            setDate={setDates}
                            loading={loading}
                            buscar={getInfo}
                        />
                    </div>
                    {loading ?
                        <div hidden={loading} style={{ height: '100%', zIndex: 1000, width: '100%', background: 'rgba(204, 204, 204, 0.5)', position: loading ? 'absolute' : 'none', paddingTop: '40vh' }} className='d-flex justify-content-center transitionAll-1'>
                            <ProgressSpinner />
                        </div>
                        : ''

                    }
                    <Card className={'bg-' + config.theme.toLowerCase()} contenido={(
                        <div>
                            <h4 className='m-auto text-center'>Export </h4>
                            <div className='row'>
                                <div className="col-6">
                                    <Chart height={heightKPI} type="bar" data={ExportDataWeek.dataWeek} options={ExportDataWeek.OptionsWeek} plugins={[ChartDataLabels]} />
                                </div>
                                <div className="col-6">
                                    <Chart height={heightKPI} type='line' data={ExportDataDay.dataDay} options={ExportDataDay.OptionsDay} plugins={[ChartDataLabels]} />
                                </div>
                            </div>
                        </div>
                    )} />
                </div>
                )
            }
            />
        </div>
    )
}

export default ExportProduction